import { HomeGreeting } from './HomeGreeting';
import { HomePromptInput } from './HomePromptInput';

export const HomeIntro = () => {
  return (
    <div className="flex flex-col gap-3xl">
      <HomeGreeting />
      {/* <TodaysBriefing /> */}
      <HomePromptInput />
    </div>
  );
};
